// extracted by mini-css-extract-plugin
export default {"option":"Option_option__foxgc","top":"Option_top__Y4F5k","icon":"Option_icon__OttiD","description":"Option_description__jkSaS"};